import {Component, Event, EventEmitter, h, Host, Prop, State} from '@stencil/core';
import {replaceText} from "../../common/i18n-util";

import "@bun-ui/icons";
import "@bun-ui/layout";
import "@bun-ui/links";
import "@bun-ui/markdown-renderer";

@Component({
  tag: 'lb-context-switch',
  styleUrl: "styles.scss",
  shadow: true,
})
export class ContextSwitch {

  /**
   * language
   */
  @Prop({reflect: true}) language: string = "de";
  /**
   * User Account Type buerger or organisation
   */
  @Prop({reflect: true}) userKontentyp: 'buerger' | 'organisation';
  /**
   * Form Type buerger or organisation
   */
  @Prop({reflect: true}) formularTyp: 'buerger' | 'organisation' | 'hybrid';
  /**
   * Does the form support offline-Versand?
   */
  @Prop({reflect: true}) supportsOfflineversand = false;
  /**
   * trust level required by form
   */
  @Prop({reflect: true}) requiredTrustLevel: string; // | 'UNTERGEORDNET' | 'EIDAS_NIEDRIG' | 'EIDAS_SUBSTANZIELL' | 'EIDAS_HOCH';
  /**
   * trust level required by form in human readable form
   */
  @Prop({reflect: true}) requiredTrustLevelName: string;
  /**
   * trust level sufficient
   */
  @Prop({reflect: true}) trustlevelNotSufficient = true;

  /**
   * Eventemitter for "zur Antragsstellung" button
   * Results in eventEmitter
   * @returns {EventEmitter<string>} with possible values: "buerger" and "organisation"
   */
  @Event() zurAntragsstellung: EventEmitter<string>;

  @State() options_message: string;
  @State() message: string;

   // "meta" texts in selected language
  @Prop({mutable: true}) i18n;

  getI18n(msgKey) {
    let beantragungData = this.i18n?.beantragung;
    if (!beantragungData || !beantragungData.hasOwnProperty(msgKey)) {
      return;
    }
    let msg = beantragungData[msgKey];

    let trustLevelTranslated = this.i18n?.trustlevel?.['trustlevel_' + this.requiredTrustLevel];
    if (!trustLevelTranslated) {
      return;
    }

    return replaceText(msg, 'trustlevel', trustLevelTranslated);
  }

  componentWillRender() {
    let account = this.formularTyp === 'hybrid' ? this.userKontentyp : this.formularTyp;
    let messageKey;
    let optionsKey;
    if (account === 'organisation') {
      messageKey = 'switchContextTextOrga';
      optionsKey = 'switchContextOptionsOrgaSubstanziell'
    } else {
      messageKey = 'switchContextTextBuerger';
      if (this.requiredTrustLevel === 'eidas_hoch') {
        optionsKey = 'switchContextOptionsBuergerHoch';
      } else {
        optionsKey = 'switchContextOptionsBuergerSubstanziell';
      }
    }
    this.message = this.getI18n(messageKey);
    this.options_message = this.getI18n(optionsKey);
  }

  render() {
    return (
      <Host>
        <div>
          <c-trust-level data-testid="vorschalt-trust-level-icon"
            level={this.requiredTrustLevel}
            i18n={this.i18n}
          />
          <br/>
          <c-header type="h2" role="heading">
            { this.getI18n('switchContextHeadline') }
          </c-header>
          <c-text data-testid="vorschalt-trust-level-text">
            {/*FIXME: geht es auch ohne check?*/}
            {this.options_message && (
              <c-markdown-renderer>
                <div slot="source">
                  {this.options_message}
                </div>
              </c-markdown-renderer>
            )}
            <p>{ this.message }</p>
          </c-text>
          <br/>
          <br/>
          <br/>
          <div class="controls">
            {this.supportsOfflineversand && (
              <c-button data-testid="vorschalt-denylogin-button"
                        large centered-content
                        onClick={() => {
                          this.zurAntragsstellung.emit('offline');
                        }}>{ this.getI18n('switchContextSendOfflineBtnLabel') }
              </c-button>
            )}
            {!this.supportsOfflineversand && (
              <c-button data-testid="vorschalt-denylogin-button"
                        large centered-content
                        onClick={() => {
                          window.history.back();
                        }}>{ this.getI18n('switchContextDenyLoginBtnLabel') }
              </c-button>
            )}

            <c-button data-testid="vorschalt-login-button"
                      primary large centered-content
                      onClick={() => {
                        this.zurAntragsstellung.emit('online');
                      }}>{ this.getI18n('switchContextLoginBtnLabel') }
            </c-button>
          </div>
        </div>
      </Host>
    );
  }
}